import { defineMessages } from 'react-intl';

export const dropdownMessageDefinitions = defineMessages({
  emptyPlaceholder: {
    id: 'dropdown.emptyPlaceholder',
    defaultMessage: 'Select',
  },
});
